<template>
  <v-container fluid>
    <v-layout row wrap>
      <v-flex xs12>
        <list :edit="edit" @form="dialog = true" @clear="$refs.form.clear()" />
        <form-manager
          ref="form"
          :dialog="dialog"
          :stadium-id="stadiumId"
          :edit="edit"
          @close="dialog = false"
        />
      </v-flex>
    </v-layout>
  </v-container>
</template>

<script>
import { mapState, mapActions } from 'vuex'
import FormManager from './FormManager'
import List from './List'
export default {
  name: 'Cameras',
  components: {
    List,
    FormManager,
  },
  props: {
    stadiumId: {
      type: String,
      default: '',
      required: false,
    },
    stadiumView: {
      type: Boolean,
      default: false,
      required: false,
    },
    edit: {
      type: Boolean,
      default: true,
      required: false,
    },
  },
  data() {
    return {
      dialog: false,
    }
  },
  mounted() {
    this.$store.dispatch('cameras/resetState')
    this.initData()
  },
  computed: {
    ...mapState({
      statusOfButton: (state) => state.events.status,
    }),
  },
  methods: {
    ...mapActions({
      fetchCameras: 'cameras/fetchList',
      fetchStadiums: 'stadiums/fetchSelectList',
      setStatus: 'events/setStatus',
    }),
    async initData() {
      // this.resetPagitations()

      if (!this.stadiumView) {
        this.fetchStadiums()
        await this.fetchCameras()
      }
    },
  },
  watch: {
    statusOfButton: function (val) {
      if (val) this.initData().finally(() => this.setStatus(false))
    },
    stadiumId(val) {
      if (val) {
        this.fetchCameras({ stadiumId: val })
      }
    },
  },
}
</script>
